<template>
  <b-card
    :class="{ 'clickable' : hasUrl }"
    class="thumbnail">

    <span v-if="hasUrl" class="empty">
      <i class="fas fa-file-pdf fa-3x"></i>
    </span>
    <span v-else class="empty">
      <i class="fas fa-question fa-3x"></i>
    </span>
  </b-card>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    hasUrl () {
      return this.url.length
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.thumbnail {
  width: 24rem;
  max-width: 100%;
  background: $light-secondary;

  .card-body {
    padding: 0 !important;
    text-align: center;
    line-height: 12rem;

    span {
      padding-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/pdf-preview.vue